import { gql } from 'apollo-boost';

export const GET_BY_USER = gql`
query accesses($user: String!) {
    accesses(user: $user) {
        id
        site {
        id
        name
        publisherId
        services {
          name
          enabled
          }
        }
    }      
  }  
`;

export const ADD_EDIT_ACCESS = gql`
mutation createAccess($user: String!, $site: [String!]!){
  createAccess(input: {
    sites: $site,
    user: $user
  }) {
    site {
      domain
    }
    id
  }
}
`;